import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Checkbox } from '../../subkit-ui';
import classNames from 'classnames';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWSubscriptionPlanPicker = function TWSubscriptionPlanPicker(_ref) {
  var servicePlans = _ref.servicePlans,
      selectedPlans = _ref.selectedPlans,
      setSelectedPlans = _ref.setSelectedPlans,
      planText = _ref.planText,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: servicePlans.map(function (plan) {
      if (!plan.id || !plan.name) return /*#__PURE__*/_jsx(_Fragment, {});
      var isDisabled = disabled ? disabled(plan) : false;
      return /*#__PURE__*/_jsxs("div", {
        className: classNames("flex my-2"),
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: plan.id in selectedPlans,
          disabled: isDisabled,
          dataCy: plan.name,
          onChange: function onChange(ununsed, value) {
            var dict = _objectSpread({}, selectedPlans);

            if (value) {
              dict[plan.id] = plan;
            } else {
              delete dict[plan.id];
            }

            setSelectedPlans(dict);
          }
        }), planText ? planText(plan) : plan.name]
      }, plan.id);
    })
  });
};